module.exports = __webpack_public_path__ + "img/itx-file-type-tif.80a89544.svg";